import { render, staticRenderFns } from "./TrackingReview.vue?vue&type=template&id=0ca5970d&scoped=true&"
import script from "./TrackingReview.vue?vue&type=script&lang=js&"
export * from "./TrackingReview.vue?vue&type=script&lang=js&"
import style0 from "./TrackingReview.vue?vue&type=style&index=0&id=0ca5970d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5970d",
  null
  
)

export default component.exports